import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { AdminRoute } from './components/layout/AdminRoute';
import { AppLayout } from './components/layout/AppLayout';
import { AdminLayout } from './components/layout/AdminLayout';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminChannelsPage } from './pages/admin/AdminChannelsPage';
import { AdminOperatorsPage } from './pages/admin/AdminOperatorsPage';
import { AdminPropertiesPage } from './pages/admin/AdminPropertiesPage';
import { AdminPropertyEditorPage } from './pages/admin/AdminPropertyEditorPage';
import { AdminBookingsPage } from './pages/admin/AdminBookingsPage';
import { AdminReviewsPage } from './pages/admin/AdminReviewsPage';
import { AdminLeadsPage } from './pages/admin/AdminLeadsPage';
import { AdminGuestReviewsPage } from './pages/admin/AdminGuestReviewsPage';
import { AdminFeaturedPage } from './pages/admin/AdminFeaturedPage';
import { AdminPropertyImagesPage } from './pages/admin/AdminPropertyImagesPage';
import { AdminPostingsPage } from './pages/admin/AdminPostingsPage';
import { AdminMediaPage } from './pages/admin/AdminMediaPage';
import { AdminStorefrontStoriesPage } from './pages/admin/AdminStorefrontStoriesPage';
import { AdminHomepageContentPage } from './pages/admin/AdminHomepageContentPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { VendorRoute } from './components/layout/VendorRoute';
import { VendorLayout } from './components/layout/VendorLayout';
import { VendorLoginPage } from './pages/vendor/VendorLoginPage';
import { VendorAcceptInvitePage } from './pages/vendor/VendorAcceptInvitePage';
import { VendorHealthPage } from './pages/vendor/VendorHealthPage';
import { VendorActivityPage } from './pages/vendor/VendorActivityPage';
import { VendorTeamPage } from './pages/vendor/VendorTeamPage';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { ReservationsPage } from './pages/ReservationsPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { PropertyListingEditorPage } from './pages/PropertyListingEditorPage';
import { GuestsPage } from './pages/GuestsPage';
import { ReportsPage } from './pages/ReportsPage';
import { ChannelManagerPage } from './pages/ChannelManagerPage';
import { OperationsPage } from './pages/OperationsPage';
import { PricingPage } from './pages/PricingPage';
import { OwnerDashboardPage } from './pages/OwnerDashboardPage';
import { SettingsPage } from './pages/SettingsPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { FrontDeskPage } from './pages/FrontDeskPage';
import { AvailabilityGridPage } from './pages/AvailabilityGridPage';
import { MaintenancePage } from './pages/MaintenancePage';
import { ReportsLibraryPage } from './pages/ReportsLibraryPage';
import { PropertySettingsPage } from './pages/PropertySettingsPage';
import { RatePlansPage } from './pages/RatePlansPage';
import { RoomTypesPage } from './pages/RoomTypesPage';
import { CancellationPoliciesPage } from './pages/CancellationPoliciesPage';
import { NightAuditPage } from './pages/NightAuditPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { HousekeepingPage } from './pages/HousekeepingPage';
import { GroupBookingsPage } from './pages/GroupBookingsPage';
import { RateCalendarPage } from './pages/RateCalendarPage';
import { RateParityReportPage } from './pages/RateParityReportPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { ChannelConnectionSetupPage } from './pages/ChannelConnectionSetupPage';
import { OAuthCallbackPage } from './pages/OAuthCallbackPage';
import { EmailLogsPage } from './pages/EmailLogsPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { BillsPage } from './pages/BillsPage';
import { PropertyHubPage } from './pages/PropertyHubPage';
import { RetailKeyPage } from './pages/RetailKeyPage';
import { ShiftManagementPage } from './pages/ShiftManagementPage';
import { MiscExpensePage } from './pages/MiscExpensePage';
import { MiscRevenuePage } from './pages/MiscRevenuePage';
import { HouseAccountsPage } from './pages/HouseAccountsPage';
import { HouseInventoryPage } from './pages/HouseInventoryPage';
import { LostFoundPage } from './pages/LostFoundPage';
import { ChargeTypesPage } from './pages/ChargeTypesPage';
import { PromotionCodesPage } from './pages/PromotionCodesPage';
import { CancellationReasonsPage } from './pages/CancellationReasonsPage';
import { DepositPoliciesPage } from './pages/DepositPoliciesPage';
import { PackagesPage } from './pages/PackagesPage';
import { HousekeepingServiceTypesPage } from './pages/HousekeepingServiceTypesPage';
import { GuestEngagementPage } from './pages/GuestEngagementPage';
import { ProductsPage as RetailProductsPage } from './pages/retail/ProductsPage';
import { StockPage as RetailStockPage } from './pages/retail/StockPage';
import { LookupsPage as RetailLookupsPage } from './pages/retail/LookupsPage';
import { PaidOutsPage } from './pages/retail/PaidOutsPage';
import { RetailHouseAccountsPage } from './pages/retail/RetailHouseAccountsPage';
import { VendorsPage } from './pages/retail/VendorsPage';
import { RetailConfigPage } from './pages/retail/RetailConfigPage';
import { RetailReportsPage } from './pages/retail/RetailReportsPage';
import { ReportsSchedulerPage } from './pages/ReportsSchedulerPage';
import { DataExtractsPage } from './pages/DataExtractsPage';
import { ReportsStatisticsPage } from './pages/ReportsStatisticsPage';

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* BestAcco platform (super-admin) portal — its own shell, fenced by AdminRoute */}
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<AdminOverviewPage />} />
        <Route path="channels" element={<AdminChannelsPage />} />
        <Route path="operators" element={<AdminOperatorsPage />} />
        <Route path="properties" element={<AdminPropertiesPage />} />
        <Route path="properties/:id" element={<AdminPropertyEditorPage />} />
        <Route path="bookings" element={<AdminBookingsPage />} />
        <Route path="reviews" element={<AdminReviewsPage />} />
        <Route path="leads" element={<AdminLeadsPage />} />
        <Route path="featured" element={<AdminFeaturedPage />} />
        <Route path="guest-reviews" element={<AdminGuestReviewsPage />} />
        <Route path="property-images" element={<AdminPropertyImagesPage />} />
        <Route path="postings" element={<AdminPostingsPage />} />
        <Route path="media" element={<AdminMediaPage />} />
        <Route path="storefront-stories" element={<AdminStorefrontStoriesPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="homepage-content" element={<AdminHomepageContentPage />} />
      </Route>

      {/* Vendor observability realm (TASK-144) — a SEPARATE authenticated area,
          its own token layer + guard, never mixed with staff/admin routes. */}
      <Route path="/vendor/login" element={<VendorLoginPage />} />
      <Route path="/vendor/accept-invite" element={<VendorAcceptInvitePage />} />
      <Route
        path="/vendor"
        element={
          <VendorRoute>
            <VendorLayout />
          </VendorRoute>
        }
      >
        <Route index element={<VendorHealthPage />} />
        <Route path="activity" element={<VendorActivityPage />} />
        <Route
          path="team"
          element={
            <VendorRoute adminOnly>
              <VendorTeamPage />
            </VendorRoute>
          }
        />
      </Route>

      {/* Onboarding — protected but outside AppLayout (full-screen wizard) */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <OnboardingPage />
          </ProtectedRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/front-desk" replace />} />
        <Route path="hub" element={<PropertyHubPage />} />
        <Route path="retailkey" element={<RetailKeyPage />} />
        <Route path="retailkey/products" element={<RetailProductsPage />} />
        <Route path="retailkey/stock" element={<RetailStockPage />} />
        <Route path="retailkey/lookups" element={<RetailLookupsPage />} />
        <Route path="retailkey/paid-outs" element={<PaidOutsPage />} />
        <Route path="retailkey/house-accounts" element={<RetailHouseAccountsPage />} />
        <Route path="retailkey/vendors" element={<VendorsPage />} />
        <Route path="retailkey/config" element={<RetailConfigPage />} />
        <Route path="retailkey/reports" element={<RetailReportsPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="front-desk" element={<FrontDeskPage />} />
        <Route path="reservations" element={<ReservationsPage />} />
        <Route path="availability" element={<AvailabilityGridPage />} />
        <Route path="maintenance" element={<MaintenancePage />} />
        <Route path="shift-management" element={<ShiftManagementPage />} />
        <Route path="misc-expense" element={<MiscExpensePage />} />
        <Route path="misc-revenue" element={<MiscRevenuePage />} />
        <Route path="house-accounts" element={<HouseAccountsPage />} />
        <Route path="house-inventory" element={<HouseInventoryPage />} />
        <Route path="lost-found" element={<LostFoundPage />} />
        {/* TASK-68 — Administration config screens */}
        <Route path="charge-types" element={<ChargeTypesPage />} />
        <Route path="promotion-codes" element={<PromotionCodesPage />} />
        <Route path="cancellation-reasons" element={<CancellationReasonsPage />} />
        <Route path="deposit-policies" element={<DepositPoliciesPage />} />
        <Route path="packages" element={<PackagesPage />} />
        <Route path="housekeeping-service-types" element={<HousekeepingServiceTypesPage />} />
        <Route path="guest-engagement" element={<GuestEngagementPage />} />
        <Route path="properties" element={<PropertiesPage />} />
        <Route path="properties/:id/listing" element={<PropertyListingEditorPage />} />
        <Route path="guests" element={<GuestsPage />} />
        <Route path="reports" element={<ReportsLibraryPage />} />
        <Route path="reports/scheduler" element={<ReportsSchedulerPage />} />
        <Route path="reports/extracts" element={<DataExtractsPage />} />
        <Route path="reports/statistics" element={<ReportsStatisticsPage />} />
        <Route path="reports-legacy" element={<ReportsPage />} />
        <Route path="channel-manager" element={<ChannelManagerPage />} />
        <Route path="channels/connect" element={<ChannelConnectionSetupPage />} />
        <Route path="oauth/callback/airbnb" element={<OAuthCallbackPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="housekeeping" element={<HousekeepingPage />} />
        <Route path="rate-calendar" element={<RateCalendarPage />} />
        <Route path="rate-parity" element={<RateParityReportPage />} />
        <Route path="rate-plans" element={<RatePlansPage />} />
        <Route path="room-types" element={<RoomTypesPage />} />
        <Route path="cancellation-policies" element={<CancellationPoliciesPage />} />
        <Route path="property-settings" element={<PropertySettingsPage />} />
        <Route path="night-audit" element={<NightAuditPage />} />
        <Route path="group-bookings" element={<GroupBookingsPage />} />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="owner-dashboard" element={<OwnerDashboardPage />} />
        <Route path="users" element={<UserManagementPage />} />
        <Route path="email-logs" element={<EmailLogsPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="bills" element={<BillsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/front-desk" replace />} />
    </Routes>
  );
}
